module.exports = __webpack_public_path__ + "static/media/ig16.ecedbaac.jpg";